export const REGION_TYPES = {
  ALL: "All Regions",
  NATIONAL: "National",
  MULTISTATE: "Multi-State (2 or more)",
  STATEWIDE: "Statewide",
  COMMUNITY: "Community",
  MULTIPROVINCE: "Multi-province (2 or more)",
  PROVINCEWIDE: "Provincewide",
};
